// extracted by mini-css-extract-plugin
export default {"video":"Video_video__ite1X","wrap":"Video_wrap__3vBtG"};